import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IVaccineNameModel extends IModel {
  vaccineNameId: number;
  name: string;
}

export class VaccineNameModel
  extends Model
  implements ModelRecord<IVaccineNameModel>
{
  vaccineNameId: number;
  name: string;

  constructor(params?: Partial<IVaccineNameModel>) {
    super(params);

    this.vaccineNameId = defaultTo(params?.vaccineNameId, 0);
    this.name = defaultTo(params?.name, '');
  }
}
